import { toString as qrToString } from "qrcode";

/**
 * Renders `text` as a QR code SVG and returns it as a data: URL for an <img>.
 * Error correction "Q" (~25% damage tolerance) suits stickers that get scuffed;
 * a 2-module quiet zone keeps the code scannable when trimmed close.
 */
export async function qrSvgDataUrl(text: string): Promise<string> {
  const svg = await qrToString(text, { type: "svg", errorCorrectionLevel: "Q", margin: 2 });
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
